import wrapError from "@/components/helpers/wrapError"
import wrapSuccess from "@/components/helpers/wrapSuccess"

export const apiGetUsers = (funcToDispatch, newPage, error, callback) => {
  $.ajax({
    type: "GET",
    url: `/api/admin/adminManager?page=${newPage}`,
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiGetUsers"),
  })
}

export const apiChangeUserStatus = (params, funcToDispatch, error, callback) => {
  $.ajax({
    type: "PUT",
    url: "/api/admin/adminManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiChangeUserStatus"),
  })
}

export const apiGetRoles = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/admin/role",
    success,
    error: wrapError(error, "apiGetRoles"),
  })
}

export const apiCreateRole = (params, success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/role",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success,
    error: wrapError(error, "apiCreateRole"),
  })
}

export const apiUpdateRole = (roleId, params, success, error) => {
  $.ajax({
    type: "PUT",
    url: `/api/admin/role/${roleId}`,
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success,
    error: wrapError(error, "apiUpdateRole"),
  })
}

export const apiDeleteRole = (roleId, success, error) => {
  $.ajax({
    type: "DELETE",
    url: `/api/admin/role/${roleId}`,
    success,
    error: wrapError(error, "apiDeleteRole"),
  })
}

export const apiGetConstituentRoles = (success, error) => {
  $.ajax({
    type: "GET",
    url: "/api/admin/constituentRole",
    success,
    error: wrapError(error, "apiGetConstituentRoles"),
  })
}

export const apiAssignRole = (params, funcToDispatch, error, callback) => {
  $.ajax({
    type: "POST",
    url: "/api/admin/constituentRole",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiCreateRole"),
  })
}

export const apiDeleteAssignedRole = (assignedRoleId, funcToDispatch, error, callback) => {
  $.ajax({
    type: "DELETE",
    url: `/api/admin/constituentRole/${assignedRoleId}`,
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiDeleteAssignedRole"),
  })
}
